export default __webpack_public_path__ + "static/media/talk-icon.08bfff2e.webp";